/* eslint-disable import/no-named-as-default-member */
/* eslint-disable import/no-named-as-default */
import React, { useEffect } from 'react';
import { Image, notification } from 'antd';
import { CheckCircleOutlined, InfoCircleOutlined, NotificationOutlined } from '@ant-design/icons';
import { getAuth, signInAnonymously } from 'firebase/auth';
import { getToken, getMessaging } from 'firebase/messaging';
import app from '../firebase';
import { useStateValue } from '../providers/StateProvider';
import doAxiosRequest from '../utils/doAxiosRequest';
import catchError from '../utils/catchError';

const useTokenNotifGeneration = () => {
    const [{ lvl, id, token: tkn, tokenFirebase, triggerService }, dispatch] = useStateValue();

    const vapidKey = (window.location.hostname === 'buzon.ased.gob.mx')
        ? 'BLmO6AUUs3Qr0CRbKMdULsxnIRws4dRtGpL6s92zQpd7k1hjkKkDq3egIfaeHbNUa9FOayH3ODFteBtOB0lDNSY'
        : 'BOOA5oAjWGkydKbb44FVgSW-WXbuTOqZnqYkGjNMYVt1GsJi-jR7fqYe00rt9o5clW_b8oP19nAi_rJLF9zV0y0';

    const enableNotification = async () => {
        notification.open({
            message: 'Activa las notificaciones',
            description:
                'Para mejorar la experiencia de uso: activa las notificaciones, por favor.',
            icon: <NotificationOutlined style={{ color: '#108ee9' }} />,
            placement: 'bottomLeft',
            duration: 5,
            key: 0,
        });

        const noti = await Notification.requestPermission();
        if (noti === 'granted') {
            dispatch({
                type: 'TRIGGER_ACTION',
                item: 'Service',
            });
        }
    };

    const notificationDisabled = () => {
        notification.open({
            message: 'Notificaciones deshabilitadas',
            description:
            'No se mostrarán notificaciones en tu dispositivo; esto no afectara ninguna funcionalidad.',
            icon: <InfoCircleOutlined style={{ color: '#ff4d4f' }} />,
            placement: 'bottomLeft',
            duration: 4,
        });
    };

    const openNotificationActivated = () => {
        notification.close(0);
        notification.open({
            message: '¡Notificaciones activadas!',
            description:
                'Recibirás notificaciones y otras alertas en tu dispositivo.',
            icon: <CheckCircleOutlined style={{ color: '#73d13d' }} />,
            placement: 'bottomLeft',
            duration: 4,
        });
    };

    useEffect(() => {
        const registerTokenBD = catchError(async () => {
            if (tokenFirebase !== 'null' && tokenFirebase && id && localStorage.getItem('fl') !== '1') {
                const body = {
                    id,
                    tipo: lvl === '1' ? 'entidad' : lvl === '2' ? 'admins' : 'auditor',
                    token: tokenFirebase,
                };

                const { ok } = await doAxiosRequest(
                    '/general/general/token',
                    'POST',
                    tkn,
                    dispatch,
                    body,
                );
                ok && openNotificationActivated();
                localStorage.setItem('fl', '1');
            }
        });

        registerTokenBD();
    }, [tokenFirebase]);

    useEffect(() => {
        if ((!localStorage.getItem('tf') || localStorage.getItem('tf') === 'null') && id) {
            navigator.serviceWorker.ready.then((serviceWorkerRegistration) => {
                // eslint-disable-next-line no-restricted-syntax
                if (!('Notification' in window)) {
                    console.warn('Este navegador no es compatible con las notificaciones de escritorio');
                    return;
                }
                if (Notification.permission === 'default') {
                    return enableNotification();
                } else if (Notification.permission === 'denied') {
                    return notificationDisabled();
                }
                signInAnonymously(getAuth());
                const messaging = getMessaging(app);
                getToken(messaging, { vapidKey, serviceWorkerRegistration }).then((tokentf) => {
                    localStorage.setItem('tf', tokentf);
                    dispatch({
                        type: 'ADD_TOKEN_FIREBASE',
                        item: tokentf,
                    });
                }).catch((err) => {
                    console.warn(err);
                });
            });
        }
    }, [id, triggerService]);

    const eventListener = ({ data }) => {
        const { isFirebaseMessaging, data: customData } = data;
        const { ruta, tipo, title, body, image } = customData;

        if (ruta) {
            dispatch({
                type: 'NOTIFICATION_URL',
                item: { type2: ruta },
            });
        }
        dispatch({
            type: 'NOTIFICATION_TRIGGER',
            item: { type: parseInt(tipo, 10) },
        });

        dispatch({
            type: 'TRIGGER_ACTION',
            item: 'NewAlert',
        });

        if (isFirebaseMessaging) {
            notification.info({
                message: title,
                description: body,
                icon: (<Image
                    width={40}
                    height={40}
                    src={image}
                />),
                onClick: () => {
                    open(ruta);
                },
            });
        }
    };

    useEffect(() => {
        if (tokenFirebase !== 'null' && tokenFirebase && id) {
            navigator.serviceWorker.addEventListener('message', eventListener);
        }
        return () => {
            navigator.serviceWorker.removeEventListener('message', eventListener);
        };
    }, [id, tokenFirebase, triggerService]);
};

export default useTokenNotifGeneration;
